import {
  CreateWidgetPayload,
  FileUploadResponse,
  WidgetItem,
  WidgetListResponse,
  WidgetPayloadFinal,
} from "utils/api/client/types"

export class Widgets {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    body: WidgetPayloadFinal,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<WidgetItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/widgets`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(id: string, body: WidgetPayloadFinal): Promise<WidgetItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/widgets/${id}`, {
        method: "PUT",
        body,
      })
    })()
  }

  list(
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<WidgetListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/widgets`, {
        headers,
        query: queryParams,
      })
    })()
  }

  retrieve(id: string): Promise<WidgetItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/widgets/${id}`)
    })()
  }

  delete(id: string, headers?: Record<string, unknown>): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/widgets/${id}`, {
        method: "DELETE",
        headers,
      })
    })()
  }

  createImage(payload: { image: File }): Promise<FileUploadResponse> {
    return (async () => {
      const body = new FormData()
      body.append("image", payload.image)
      return await (this.client as any).fetch(`/admin/events/image`, {
        method: "POST",
        headers: {
          "content-type": null,
        },
        body,
      })
    })()
  }
}
